import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IviSubscriptionsComponent } from './ivi-subscriptions/ivi-subscriptions.component';
import { IviSubscriptionPackageDetailsComponent } from './ivi-subscription-package-details/ivi-subscription-package-details.component';
import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { IviContainerComponent } from './ivi-container/ivi-container.component';
import { MatGridListModule } from '@angular/material/grid-list';
import { provideTranslateService, TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { provideHttpClient } from '@angular/common/http';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { IviErrorScreenComponent } from './ivi-error-screen/ivi-error-screen.component';

/**
 * The `IviModule` is an Angular feature module that encapsulates components and dependencies
 * related to IVI subscriptions and package management. It declares components for displaying
 * subscription information, selected packages, package details, container layout, and terms
 * and conditions. The module imports common Angular modules and Material Grid List for UI layout.
 * It also provides global configuration for Angular Material steppers.
 *
 * @exports IviSubscriptionsComponent
 */
@NgModule({
  declarations: [
    IviSubscriptionsComponent,
    IviSubscriptionPackageDetailsComponent,
    IviContainerComponent,
    IviErrorScreenComponent
  ],

  imports: [
    CommonModule,
    MatGridListModule,
    TranslateModule,
    RouterModule
  ],
  providers: [
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: { displayDefaultIndicatorType: false }
    },
    provideHttpClient(),
    provideTranslateService({
      loader: provideTranslateHttpLoader({
        prefix: './assets/i18n/', 
        suffix: '.json',
      }),
      fallbackLang: 'en-US', 
      lang: 'en-US',
    })
  ],
  exports: [TranslateModule, IviSubscriptionsComponent, IviErrorScreenComponent]
})
export class IviModule { }
